/* eslint-disable camelcase */
import patioData from "components/patio-configurator/data";
import { isCartTransformLine } from "@root/constants/cart-transform";
import extractGid from "./extract-gid";

const getStableCheckout = async (checkout, inputRefs) => {
    const data = {
        items: checkout.items.map((item) => {
            // Cart Transform lines already carry their final attributes. If one ends up in a
            // draft order (mixed cart), the PMS prices it from `_formula_params`.
            if (isCartTransformLine(item)) {
                return {
                    id: item.node.id,
                    product_id: +extractGid(item.node.merchandise.product.id),
                    variant_id: +extractGid(item.node.merchandise.id),
                    quantity: +item.node.quantity,
                    price: +item.node.merchandise.price.amount * 100,
                    properties: Object.fromEntries(item.node.attributes.map(({ key, value }) => [key, value])),
                };
            }

            const attributes = item?.node.attributes?.length > 0 ? item.node.attributes.reduce((array, value) => ({
                ...array,
                ...(value.key !== "handle" && { [value.key.charAt(0).toUpperCase() + value.key.slice(1)]: value.value }),
            }), {}) : {};

            const dynamicAttributes = item?.node.attributes.filter((attr) => attr.key.startsWith("c_") || attr.key === "_measurements")
                .reduce((obj, attr) => ({
                    ...obj,
                    [attr.key.replace("c_", "")]: attr.value,
                }), {});

            const analyticsAttributes = item?.node.attributes.filter((attr) => attr.key.startsWith("_item_category") || attr.key.startsWith("_item_variant"))
                .reduce((obj, attr) => ({
                    ...obj,
                    [attr.key]: attr.value,
                }), {});

            const patioInputs = item?.node?.attributes?.filter((node) => inputRefs?.find((inp) => inp?.key === node?.key)).map((attr) => ({ name: inputRefs?.find((inp) => inp.key === attr.key).name, value: attr.value }));
            const referenceImages = Object.fromEntries(
                Object.entries(attributes)
                    .filter(([key]) => key.startsWith("ReferenceImage"))
                    .map(([key, value], index) => [`Image${index === 0 ? "" : ` ${index + 1}`}`, value]),
            );

            return ({
                id: item.node.id,
                product_id: +extractGid(item.node.merchandise.product.id),
                variant_id: +extractGid(item.node.merchandise.id),
                quantity: +item.node.quantity,
                ...(item.node.attributes.filter((attr) => attr.key === "_customProduct")[0]
                    ? {
                        price: +item.node.merchandise.price.amount * 100,
                        properties: {
                            _customProduct: "Yes",
                            __productData: attributes.__productData,
                            __basePrice: attributes.__basePrice,
                            _productImage: attributes._productImage,
                            _squareFeet: attributes._squareFeet,
                            _cutPieces: attributes._cutPieces,
                            ...({
                                ...patioInputs.reduce((array, input) => ({
                                    ...array,
                                    [input.name]: input.value,
                                }), {}),
                            }),
                            ...dynamicAttributes,
                            ...referenceImages,
                            ...(attributes?.SpecialRequest && { "Special Request": attributes.SpecialRequest }),
                            ...analyticsAttributes,
                        },
                    }
                    : { price: +item.node.merchandise.price.amount, properties: attributes ?? {} }),
            });
        }),
        discountCode: checkout.discountCode,
    };
    return data;
};


export default getStableCheckout;
